import { render, staticRenderFns } from "./dyeingAndFinishingOrderDetail.vue?vue&type=template&id=ced43682&scoped=true"
import script from "./dyeingAndFinishingOrderDetail.vue?vue&type=script&lang=js"
export * from "./dyeingAndFinishingOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./dyeingAndFinishingOrderDetail.vue?vue&type=style&index=0&id=ced43682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced43682",
  null
  
)

export default component.exports